module.exports = __webpack_public_path__ + "static/img/02450_5.3ed121e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02450_5.jpg
// module id = HcYo
// module chunks = 1